import React from "react";
import { useNavigate } from "react-router-dom";

const Card = (props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/Vacancy/${props.id}`);
  };

  return (
    <div
      className="flex items-center p-4 mt-6 bg-white shadow-md rounded-xl cursor-pointer hover:shadow-lg"
      onClick={handleClick}
    >
      <div className="w-24 h-24 overflow-hidden rounded-full mr-4">
        <img
          src={props.company_image_url}
          alt={props.company_name}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex-1">
        <h5 className="text-lg font-semibold text-blue-gray-900">
          {props.title}
        </h5>
        <p className="text-sm text-gray-600">{props.company_name}</p>
        {props.job_status === 1 ? (
          <p className="text-sm text-gray-600">di Buka</p>
        ) : (
          <p className="text-sm text-gray-600">di Tutup</p>
        )}
        <p className="text-sm text-gray-600">{props.company_city}</p>
      </div>
      <div className="ml-4">
        <button
          className="text-xs font-bold uppercase py-2 px-4 rounded-lg bg-gray-900 text-white hover:bg-gray-700"
          type="button"
        >
          Read More
        </button>
      </div>
    </div>
  );
};

export default Card;
